import React from "react";
import { CardTheme } from "../types";

interface SkipSymbolProps {
  theme: CardTheme;
}

export const SkipSymbol: React.FC<SkipSymbolProps> = React.memo(({ theme }) => {
  const { width, height } = theme.card;
  const centerX = width / 2;
  const centerY = height / 2;
  const size = Math.min(width, height) * 0.25;
  const strokeWidth = size * 0.12;
  const cornerFontSize = width * 0.12;

  // Draw a circle with a diagonal line through it (skip symbol)
  return (
    <g>
      {/* Circle */}
      <circle
        cx={centerX}
        cy={centerY}
        r={size / 2}
        fill="none"
        stroke={theme.symbol.color}
        strokeWidth={strokeWidth}
      />
      {/* Diagonal line with arrow */}
      <path
        d={`M ${centerX - size * 0.35} ${centerY - size * 0.35}
            L ${centerX + size * 0.25} ${centerY + size * 0.25}
            L ${centerX + size * 0.15} ${centerY + size * 0.25}
            M ${centerX + size * 0.25} ${centerY + size * 0.25}
            L ${centerX + size * 0.15} ${centerY + size * 0.35}`}
        stroke={theme.symbol.color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Top-left corner symbol */}
      <text
        x={width * 0.15}
        y={height * 0.2}
        fontSize={cornerFontSize}
        fontWeight="bold"
        fill={theme.symbol.color}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
      >
        ⏭
      </text>

      {/* Bottom-right corner symbol (rotated) */}
      <text
        x={width * 0.85}
        y={height * 0.8}
        fontSize={cornerFontSize}
        fontWeight="bold"
        fill={theme.symbol.color}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
        transform={`rotate(180 ${width * 0.85} ${height * 0.8})`}
      >
        ⏭
      </text>
    </g>
  );
});

SkipSymbol.displayName = "SkipSymbol";
